import { render, staticRenderFns } from "./costorder.vue?vue&type=template&id=1091c240&scoped=true&"
import script from "./costorder.vue?vue&type=script&lang=js&"
export * from "./costorder.vue?vue&type=script&lang=js&"
import style0 from "./costorder.vue?vue&type=style&index=0&id=1091c240&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1091c240",
  null
  
)

export default component.exports